import React from 'react';
import './StyledButton.css';

const StyledButton = ({ 
  children, 
  isActive = false, 
  onClick, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  return (
    <button 
      className={`styled-button ${isActive ? 'active' : ''} ${variant} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default StyledButton;